module.exports = __webpack_public_path__ + "static/media/virtual_e_training_gray.a507b6ef.svg";